import { render, staticRenderFns } from "./toothPosition.vue?vue&type=template&id=6150af1f&scoped=true&"
import script from "./toothPosition.vue?vue&type=script&lang=js&"
export * from "./toothPosition.vue?vue&type=script&lang=js&"
import style0 from "./toothPosition.vue?vue&type=style&index=0&id=6150af1f&prod&lang=scss&scoped=true&"
import style1 from "./toothPosition.vue?vue&type=style&index=1&id=6150af1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150af1f",
  null
  
)

export default component.exports